export const MEMBER_MANGER = 'MEMBER_MANGER';